module.exports = __webpack_public_path__ + "partnerBannerLeftSide_tablet.png";